import _ from 'lodash'
import axios from '@/plugins/axios'
import { MessageBox } from 'element-ui'
import {TableComponent, ColumnComponent, FormComponent, ProcessComponent} from './component'
import {UUID} from '../../plugins/common'
import Table from './table'
import {getProperties} from '@/store/form/componentDefaults.js'

export default class FormService {
  schema
  component
  options = {
    reports: [],
    dataSourceReports: [],
    tables: []
  }

  constructor (schema, form) {
    this.schema = schema
    this.component = form
  }

  loadTables () {
    axios.get('/data-api/table')
      .then(res => {
        this.options.tables = res.data.map(m => Table.load(m))
      })
  }

  loadDataReports () {
    axios.get('/report-api/report/definition/dataSourceReports')
      .then(res => {
        this.options.dataSourceReports = res.data
      })
  }

  loadTable (tableId) {
    return new Promise((resolve, reject) => {
      let table = this.getAllTable().find(m => m.id === tableId)
      if (table && table.columns.length === 0) {
        axios.get(`/data-api/table/${tableId}`)
          .then(res => {
            // 因为上面的 table 是克隆出来的的, 对其进行修改不会改变 options 里面的东西, 所以在这里重新查询一下
            this.options.tables.find(m => m.id === tableId).reload(res.data)
            resolve(res.data.columns)
          })
      } else {
        resolve(table.columns)
      }
    })
  }

  loadDataReport (reportId) {
    return new Promise((resolve, reject) => {
      let dataSourceReport = this.options.dataSourceReports.find(m => m.id === reportId)
      if (!dataSourceReport.columns || !dataSourceReport.columns.length) {
        axios.get(`/report-api/report/definition/${reportId}?type=run`)
          .then(res => {
            let data = res.data
            let index = this.options.dataSourceReports.findIndex(n => n.id === data.id)
            if (index === 0 || index) {
              this.options.dataSourceReports[index] = data
            } else {
              this.options.dataSourceReports.push(data)
            }
            resolve(data)
          })
      } else {
        resolve(dataSourceReport)
      }
    })
  }

  build () {
    const form = _.cloneDeep(this.component)
    const schema = {
      tables: this.getUsedTables(),
      relations: this.schema.relations
    }

    form.recursion1(m => {
      m.properties = JSON.stringify(m.properties)
    })

    return {
      form, schema
    }
  }

  getParentComponent (child) {
    return this.component.find(m =>
      m.children && m.children.some(c => c.id === child.id))
  }

  getComponentById (id) {
    return this.component.find(m => m.id === id)
  }

  createComponent (componentArgs, parentComponent, index) {
    if (!componentArgs.defaults.componentType) {
      throw new Error(`component-type cannot be null.`)
    }

    let parentArchive = this.getParentArchived(parentComponent)

    let component
    switch (componentArgs.ctor) {
      case 'ColumnComponent':
        component = new ColumnComponent(componentArgs.defaults, parentArchive.tableId)
        break
      case 'TableComponent':
        component = new TableComponent(componentArgs.defaults)
        break
    }
    if (typeof index === 'number') {
      parentComponent.children.splice(index, 0, component)
    } else {
      parentComponent.children.push(component)
    }
    // 布局创建时再创建draggable
    if (component.componentType === 'rc-layout') {
      let time = 0
      if (component.name.includes('单列')) {
        time = 1
      } else if (component.name.includes('双列')) {
        time = 2
      } else if (component.name.includes('三列')) {
        time = 3
      } else if (component.name.includes('四列')) {
        time = 4
      }
      for (let i = 0; i < time; i++) {
        this.createComponent(getProperties('rc-draggable'), component)
      }
    }
    this.setComponent(component)

    return component
  }

  getParentArchived (component) {
    if (component.archive.enable) {
      return component.archive
    } else {
      return this.getParentArchived(this.getParentComponent(component))
    }
  }

  getParentArchivedComponent (component) {
    if (component.archive.enable) {
      return component
    } else {
      return this.getParentArchivedComponent(this.getParentComponent(component))
    }
  }

  setComponent (component, oldComponent) {
    let childrenComponent = []
    // 处理归档信息
    if (component.archive.enable) {
      if (component instanceof TableComponent) {
        if (this.schema.needCreateTable(component.archive)) {
          if (component.archive.tableId === component.archive.defaultArchivedId) {
            this.schema.createTable(component.archive.defaultArchivedId, component.name)
          } else {
            this.schema.loadTable(_.cloneDeep(this.options.tables.find(m => m.id === component.archive.tableId)))
          }
        }
        if (oldComponent) {
          if (component.archive.tableId !== oldComponent.archive.tableId) {
            // 删除未被使用的归档表
            this.removeUnuesdTable(component.id, oldComponent.archive.tableId)
            let newTable = this.schema.getTable(component.archive.tableId)
            let oldTable = this.schema.getTable(oldComponent.archive.tableId)
            // 子控件的归档处理
            oldComponent.archivedChildren.forEach(m => {
              if (m instanceof ColumnComponent) {
                // 老的删除
                if (oldTable) {
                  // 删除未被使用的归档列
                  this.removeUnuesdColumn(oldTable, m.id, m.archive.columnId)
                  // 处理双归档的控件 下拉与级联下拉
                  if (component.properties.archived.hasOwnProperty('showColumnId') && component.properties.archived.showColumnId !== '') {
                    this.removeUnuesdColumn(oldTable, component.id, component.properties.archived.showColumnId)
                  }
                  // 时间区间控件
                  if (component.properties.archived.hasOwnProperty('endColumnId') && component.properties.archived.endColumnId !== '') {
                    this.removeUnuesdColumn(oldTable, component.id, component.properties.archived.endColumnId)
                  }
                }
                // 新的新增
                m.archive.tableId = component.archive.tableId
                m.archive.columnId = m.archive.defaultArchivedId
                if (m.properties.dataSource && m.properties.dataSource.enable) {
                  let id = UUID.create()
                  m.properties.archived.showColumnId = id
                  newTable.createColumn(m.archive.defaultArchivedId, `${m.name}ID`, 'enum')
                  newTable.createColumn(id, `${m.name}`, 'varchar')
                } else if (m.properties.settingCascader) {
                  let cascaderId = UUID.create()
                  m.properties.archived.showColumnId = cascaderId
                  newTable.createColumn(m.archive.defaultArchivedId, `${m.name}ID`, 'enum')
                  newTable.createColumn(cascaderId, `${m.name}`, 'varchar')
                } else {
                  let dataType = (m.archive && m.archive.dataType) || 'varchar'
                  newTable.createColumn(m.archive.defaultArchivedId, m.name, dataType)
                }
              } else if (m instanceof TableComponent) {
                m.archive.primaryKey = ''
                // 这个地方用于收集当前控件下面的字表, 改变他们的关联关系. 此时父组件的归档字段还未发生改变, 直接调用会产生问题, 所以要等到父控件的归档字段改变成功之后.
                childrenComponent.push(m)
              }
            })
          }
          this.updataArchiveName(component, oldComponent)
        }
        if (!(component instanceof FormComponent)) {
          if (!(component instanceof ProcessComponent)) {
            this.setRelation(component)
          }
        }
      } else if (component instanceof ColumnComponent) {
        // 处理列控件
        let table = this.schema.getTable(component.archive.tableId)
        // 没有找到表格说明是新建表单, 使用schema的第一张表
        if (!table) {
          table = this.schema.tables[0]
          component.archive.columnId = component.archive.defaultArchivedId
          component.archive.tableId = table.id
        }
        // 如果归档表中没有该列 则 新建一个列
        if (table.needCreateColumn(component.archive)) {
          // 老的控件不归档切归档的时候defaultArchivedId是重新生成的, 但是columnId是已经存在的, 所以需要把老的columnId替换成新的
          component.archive.columnId = component.archive.defaultArchivedId
          let newColumnName = component.name
          if (component.componentType === 'rc-time-interval') {
            newColumnName = `${component.name}开始时间`
          } else if (component.componentType === 'rc-cascader') {
            newColumnName = `${component.name}ID`
          }
          table.createColumn(component.archive.defaultArchivedId, newColumnName, component.archive.dataType)
        }

        // 处理特殊控件的归档
        this.handleSpecialComponentsArchive(component, oldComponent, table)

        if (oldComponent) {
          if (component.archive.columnId !== oldComponent.archive.columnId) {
            this.removeUnuesdColumn(table, component.id, oldComponent.archive.columnId)
          }
          if (component.properties.archived.hasOwnProperty('endColumnId') && oldComponent.properties.archived.endColumnId !== '' &&
            oldComponent.properties.archived.endColumnId !== component.properties.archived.endColumnId) {
            this.removeUnuesdColumn(table, component.id, oldComponent.properties.archived.endColumnId)
          }

          // 修改控件的归档类型，之前是值保留第一次的归档类型
          const column = table.getColumn(component.archive.columnId)
          if (column) {
            column.dataType = component.archive.dataType
          }
          if (component.properties.archived.hasOwnProperty('endColumnId') && oldComponent.properties.archived.endColumnId !== '') {
            const column2 = table.getColumn(component.properties.archived.endColumnId)
            column2.dataType = component.archive.dataType
          }
          // if (component.archive.enable && !(component instanceof TableComponent)) {
          //   let table1 = this.schema.getTable(component.archive.tableId)
          //   // 下拉与级联下拉 fixme: 归档列名字被修改, 导致用户修改归档字段的时候实际已修改, 但视图不会体现的问题;
          //   if (component.properties.archived.hasOwnProperty('showColumnId') && component.properties.archived.showColumnId !== '') {
          //     // 归档文本列
          //     let column1 = table1.getColumn(component.properties.archived.showColumnId)
          //     if (column1) {
          //       column1.name = `${component.name}`
          //     }
          //     // 归档字段列
          //     let column2 = table1.getColumn(component.archive.columnId)
          //     if (column2) {
          //       column2.pinyinName = `${column2.pinyinName}ID`
          //       column2.pinyinFirstChar = `${column2.pinyinFirstChar}ID`
          //       column2.name = `${component.name}ID`
          //     }
          //   }
          // }
          this.updataArchiveName(component, oldComponent)
        }
      }
    } else {
      this.handleNoArchive(component)
    }

    // 解决 先改表格属性在改表格内控件属性无法生效
    if (oldComponent && oldComponent.children) {
      component.children = oldComponent.children
    }
    // fixme
    if (oldComponent && oldComponent.properties.limit) {
      oldComponent.properties.limit = _.defaults(component.properties.limit, oldComponent.properties.limit)
    }
    // 数据源单独处理
    if (oldComponent && component.componentType === 'rc-data-source') {
      oldComponent.properties.dataSourceData.filter = component.properties.dataSourceData.filter
    }
    // fixme: 这么写没考虑过数组吗？。。如果是数组数据删除了的话 数组的长度最长的那个数组的长度。
    // _.merge(oldComponent, component)
    // 合并时如果是数组则直接使用新值
    _.mergeWith(oldComponent, component, (oldVal, newVal) => {
      if (_.isArray(oldVal) && _.isArray(newVal)) {
        return newVal
      }
    })

    // this code is shit
    childrenComponent.forEach(m => {
      this.setRelation(m)
    })
  }

  // 处理特殊控件的归档
  handleSpecialComponentsArchive (component, oldComponent, table) {
    // 处理下拉框双归档
    if (component.properties.dataSource && component.componentType === 'rc-combobox') {
      if (component.properties.dataSource.enable) {
        // 下拉框开启数据源归档之后 才 创建一个归档文本列 同时将原来的归档文本列改为归档ID列
        if (component.properties.archived.showColumnId === '') {
          let id = UUID.create()
          let column = table.getColumn(component.archive.columnId)
          component.properties.archived.showColumnId = id
          table.createColumn(id, `${component.name}`, 'varchar')
          // 同时如果用户没有手动改过归档列则变更原来的归档列名称
          if (column && column.name === component.name) {
            column.pinyinName = `${column.pinyinName}ID`
            column.pinyinFirstChar = `${column.pinyinFirstChar}ID`
            column.name = `${component.name}ID`
          }
        } else if (oldComponent &&
          oldComponent.properties.archived.showColumnId !== '' &&
          oldComponent.properties.archived.showColumnId !== component.properties.archived.showColumnId) {
          this.removeUnuesdColumn(table, component.id, oldComponent.properties.archived.showColumnId)
        }
      } else {
        if (component.properties.archived.showColumnId !== '') {
          this.removeUnuesdColumn(table, component.id, component.properties.archived.showColumnId)
          component.properties.archived.showColumnId = ''
        }
      }
    }
    // 处理时间区间控件双归档
    if (component.properties.archived.hasOwnProperty('endColumnId')) {
      if (component.properties.archived.endColumnId === '') {
        let id = UUID.create()
        component.properties.archived.endColumnId = id
        table.createColumn(id, `${component.name}结束时间`, component.archive.dataType)
      }
    }
    // 处理级联下拉归档
    if (component.properties.settingCascader) {
      if (component.properties.archived.showColumnId === '') {
        let id = UUID.create()
        component.properties.archived.showColumnId = id
        table.createColumn(id, `${component.name}`, 'varchar')
      } else if (oldComponent &&
        oldComponent.properties.archived.showColumnId !== '' &&
        oldComponent.properties.archived.showColumnId !== component.properties.archived.showColumnId) {
        this.removeUnuesdColumn(table, component.id, oldComponent.properties.archived.showColumnId)
      }
    }
  }

  handleNoArchive (component) {
    if (component instanceof TableComponent && component.archive) {
      if (component.archive.tableId) {
        this.removeUnuesdTable(component.id, component.archive.tableId)
        component.archivedChildren.forEach(m => {
          if (m instanceof ColumnComponent) {
            m.archive.enable = false
          } else if (m instanceof TableComponent) {
            // todo: 遇见再说吧
          }
        })
      }
    } else if (component.archive) {
      let table = this.schema.getTable(component.archive.tableId)
      if (table) {
        this.removeUnuesdColumn(table, component.id, component.archive.columnId)
        // 下拉与级联下拉删除双归档
        if (component.properties.archived && component.properties.archived.hasOwnProperty('showColumnId') && component.properties.archived.showColumnId !== '') {
          this.removeUnuesdColumn(table, component.id, component.properties.archived.showColumnId)
        }
        if (component.properties.archived && component.properties.archived.hasOwnProperty('endColumnId') && component.properties.archived.endColumnId !== '') {
          this.removeUnuesdColumn(table, component.id, component.properties.archived.endColumnId)
        }
      }
    }
  }
  // 处理表格类组件的归档名
  handleTableComponet (component, table) {
    if (component.archive.tableId !== component.archive.defaultArchivedId) {
      if (component.name === '') {
        // 表单未命名的情况,直接等于归档表的名字
        component.name = table.name
      } else if (table.name !== component.name && component.componentType === 'rc-process') {
        // 弹出提示
        MessageBox.confirm('系统检测到流程名称和归档表名称不符, 是否修改归档表名称?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'publishMessageBox',
          center: true
        }).then(() => {
          table.name = component.name
        })
      } else if (table.name !== component.name && component.componentType !== 'rc-form') {
        // 弹出提示
        MessageBox.confirm('系统检测到控件名称和归档名字不符, 是否修改归档名字?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'publishMessageBox',
          center: true
        }).then(() => {
          table.name = component.name
        })
      }
    } else {
      table.name = component.name
    }
  }
  // 更新归档名
  updataArchiveName (component, oldComponent) {
    if (component.archive.enable) {
      let table = this.schema.getTable(component.archive.tableId)
      if (component instanceof TableComponent) {
        // 处理表格类组件
        this.handleTableComponet(component, table)
      } else {
        // 处理非表格类
        let column
        let column2
        if (component.properties.archived.hasOwnProperty('endColumnId')) {
          column = table.getColumn(component.archive.columnId)
          column2 = table.getColumn(component.properties.archived.endColumnId)
        } else if (component.properties.archived.hasOwnProperty('showColumnId')) {
          column = table.getColumn(component.archive.columnId)
          column2 = table.getColumn(component.properties.archived.showColumnId)
        } else {
          column = table.getColumn(component.archive.columnId)
        }

        // 归档不归档切换问题处理
        if (component.archive.columnId !== component.archive.defaultArchivedId) {
          // 处理(已删除)标记之后再进行比对
          let originalColumnName = column.name.replace(/\(已删除\)/g, '')
          // 如果是时间区间, 下拉框, 级联下拉的双归档, 则需要处理他们第二个归档的名字
          if (column2) {
            let originalColumnName2 = column2.name.replace(/\(已删除\)/g, '')
            // 下拉, 级联下拉
            if (component.componentType === 'rc-combobox' || component.componentType === 'rc-cascader') {
              if (originalColumnName === `${component.name}ID`) {
                column.name = originalColumnName
              }
              if (originalColumnName2 === component.name) {
                column2.name = originalColumnName2
              }
            }
            // 时间区间控件
            if (component.componentType === 'rc-time-interval') {
              if (originalColumnName === `${component.name}开始时间`) {
                column.name = originalColumnName
              }
              if (originalColumnName2 === `${component.name}结束时间`) {
                column2.name = originalColumnName2
              }
            }
            // 时间区间
          } else {
            // 如果处理完已删除标记之后名字相同, 则把归档表中的名字改回原始名字
            if (originalColumnName === component.name) {
              column.name = originalColumnName
            }
          }
          // 时间区间控件双归档, 特殊处理比对方法
          if (component.componentType === 'rc-time-interval') {
            if (column.name !== `${component.name}开始时间` || column2.name !== `${component.name}结束时间`) {
              // 弹出提示, 是否改名
              MessageBox.confirm('系统检测到控件名称和归档名字不符, 是否修改?', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'publishMessageBox',
                center: true
              }).then(() => {
                // 时间区间双归档, 改了哪个就重置哪个的
                if (component.archive.columnId !== oldComponent.archive.columnId) {
                  column.name = `${component.name}开始时间`
                } else if (component.properties.archived.endColumnId !== oldComponent.properties.archived.endColumnId) {
                  column2.name = `${component.name}结束时间`
                } else {
                  // 直接改名字两个都重置
                  column.name = `${component.name}开始时间`
                  column2.name = `${component.name}结束时间`
                }
              }).catch(() => {})
            }
          } else if (component.componentType === 'rc-combobox' || component.componentType === 'rc-cascader') {
            // 下拉框和级联下拉框控件
            // column 是更改归档之后的归档列 column2是归档文本的归档列, component是当前控件
            if ((!column2 && column.name !== component.name) || (column2 && (column.name !== `${component.name}ID` || column2.name !== component.name))) {
              // 弹出提示, 是否改名
              MessageBox.confirm('系统检测到控件名称和归档名字不符, 是否修改?', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'publishMessageBox',
                center: true
              }).then(() => {
                // 归档id改了更新归档id列的名字
                if (component.archive.columnId !== oldComponent.archive.columnId) {
                  column.name = component.name
                } else if (component.properties.archived.endColumnId !== oldComponent.properties.archived.endColumnId) {
                  // 归档文本改了则更新归档文本列的名字
                  column2.name = component.name
                } else {
                  // 下拉框开数据源归档的时候才归档名加ID
                  if ((component.properties.dataSource.enable && column2) || component.componentType === 'rc-cascader') {
                    column.name = `${component.name}ID`
                    column2.name = component.name
                  } else {
                    column.name = component.name
                  }
                }
              }).catch(() => {})
            }
          } else {
            if (column.name !== component.name) {
              // 弹出提示, 是否改名
              MessageBox.confirm('系统检测到控件名称和归档名字不符, 是否修改?', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'publishMessageBox',
                center: true
              }).then(() => {
                column.name = component.name
              }).catch(() => {})
            }
          }
        } else {
          // 归档没变时即新建的时候直接赋新的归档名
          if (component.properties.archived.hasOwnProperty('endColumnId')) {
            column2.name = `${component.name}结束时间`
            column.name = `${component.name}开始时间`
          } else if (component.properties.archived.hasOwnProperty('showColumnId') && column2) {
            column2.name = component.name
            column.name = `${component.name}ID`
          } else {
            column.name = component.name
          }
        }
      }
    }
  }
  // 更新属性, 更新控件属性的时候才会进
  updateAttr (component) {
    return new Promise((resolve, reject) => {
      const originalComponent = this.component.find(m => m.id === component.id)
      let column
      if (component instanceof ColumnComponent && component.archive.enable) {
        let table = this.schema.getTable(component.archive.tableId)
        if (table) {
          if (component.properties.dataSource && component.properties.dataSource.enable) {
            column = table.columns.find(m => `${m.name}ID` === component.name)
          } else if (component.properties.archived.hasOwnProperty('endColumnId')) {
            column = table.columns.find(m => m.name === `${component.name}开始时间`)
          } else if (component.properties.settingCascader || (originalComponent.properties.dataSource && originalComponent.properties.dataSource.enable)) {
            // 下拉框归档由打开转关闭的时候也是找ID列
            column = table.columns.find(m => m.name === `${component.name}ID`)
          } else {
            column = table.columns.find(m => m.name === component.name)
          }
        }
      }
      // 不归档的更新为归档的时候,column会不存在
      if (column && column.id !== component.archive.columnId) {
        MessageBox.confirm('已存在与该控件同名的归档字段, 您确认继续新建归档字段吗?<p class="tip">新建将导致多个同名字段</p>', '', {
          confirmButtonText: '取消',
          cancelButtonText: '确定',
          customClass: 'archived-message-box',
          dangerouslyUseHTMLString: true,
          center: true
        }).then(() => {
          return resolve('stop')
        }).catch(() => {
          this.setComponent(component, originalComponent)
          return resolve('next')
        })
      } else {
        this.setComponent(component, originalComponent)
        return resolve('next')
      }
    })
  }

  removeComponent (component) {
    if (component) {
      let pos = this.component.children.indexOf(component)

      // 删除归档字段
      this.removeComponentArchived(component)

      if (pos >= 0) {
        // 考虑删除控件的大多数情况都是删除一级组件
        this.component.children.splice(pos, 1)
      } else {
        let parentComponent = this.component.recursionGetParentComponent(component.id)
        if (parentComponent) {
          pos = parentComponent.children.indexOf(component)
          parentComponent.children.splice(pos, 1)
        } else {
          throw new Error('no parent component exists')
        }
      }
    }
  }

  removeComponentArchived (component) {
    if (component instanceof ColumnComponent) {
      // 如果列归档, 删除归档列
      if (component.archive.enable) {
        let table = this.schema.getTable(component.archive.tableId)
        this.removeUnuesdColumn(table, component.id, component.archive.columnId)
        // 级联下拉与下拉
        if (component.properties.archived.hasOwnProperty('showColumnId') && component.properties.archived.showColumnId !== '') {
          this.removeUnuesdColumn(table, component.id, component.properties.archived.showColumnId)
        }
        if (component.properties.archived.hasOwnProperty('endColumnId') && component.properties.archived.endColumnId !== '') {
          this.removeUnuesdColumn(table, component.id, component.properties.archived.endColumnId)
        }
      }
    } else {
      // 如果表归档, 删除归档表
      if (component.archive.enable) {
        this.removeUnuesdTable(component.id, component.archive.tableId)
      } else {
        // 如若不归档, 对容器下面的列执行删除操作
        component.children.forEach(m => {
          this.removeComponentArchived(m)
        })
      }
    }
  }

  getComponents () {
    const components = []
    this.component.recursion1(m => components.push(m))
    return components
  }

  getUsedTables () {
    const tableIds = this.getComponents()
      .filter(m => m instanceof TableComponent)
      .map(m => m.archive.tableId)

    return this.schema.tables.filter(m => tableIds.includes(m.tableId))
  }

  getUsedRelations () {
    const relationIds = this.getComponents()
      .filter(m => m instanceof TableComponent)
      .map(m => m.archive.relationId)

    return this.schema.relations.filter(m => relationIds.includes(m))
  }

  removeUnuesdTable (componentId, tableId) {
    // 虽然我知道这个递归是干嘛的, 但是看不出来里面的逻辑是怎么执行, 只能先改掉
    // let tableUsed = this.component.some(m => m.id !== componentId && m.archive.tableId === tableId)
    let components = this.getComponents()
    let tableUsed = false
    for (let i = 0; i < components.length; i++) {
      if (components[i] instanceof TableComponent && components[i].id !== componentId && components[i].archive.tableId === tableId) {
        tableUsed = true
        break
      }
    }
    const table = this.schema.getTable(tableId)
    if (!tableUsed || !table.isNew) {
      this.schema.removeTable(table)
    }
  }

  removeUnuesdColumn (table, componentId, columnId) {
    // 如果当前列归档列被其他归档列所引用, 则不删除当前归档列
    let components = this.getComponents()
    let columnUsed = false
    for (let i = 0; i < components.length; i++) {
      if (components[i] instanceof ColumnComponent && components[i].id !== componentId && components[i].archive.columnId === columnId) {
        columnUsed = true
        break
      }
      // 双归档的控件被引用的情况
      if (this.specialArchiveUsed(components[i], componentId)) {
        columnUsed = true
        break
      }
    }

    if (!columnUsed) {
      const column = table.getColumn(columnId)
      if (column && column.name) {
        column.name = column.name + '(已删除)'
      }
      // 不移除标识列
      if (!column || column === table.getPrimaryKey() || !column.isNew) {
        return
      }

      table.removeColumn(column)
    }
  }
  // 处理特殊的双归档控件的归档引用情况
  specialArchiveUsed (component, componentId) {
    // 下拉框
    if (component instanceof ColumnComponent &&
      component.id !== componentId &&
      component.properties.dataSource &&
      component.properties.dataSource.enable &&
      component.properties.archived.showColumnId === componentId) {
      return true
    }
    // 级联下拉框
    if (component instanceof ColumnComponent &&
      component.componentType &&
      component.componentType === 'rc-cascader' &&
      component.id !== componentId &&
      component.properties.archived.showColumnId === componentId) {
      return true
    }
    // 时间区间
    if (component instanceof ColumnComponent &&
      component.id !== componentId &&
      component.properties.archived.endColumnId !== '' &&
      component.properties.archived.endColumnId === componentId) {
      return true
    }
    return false
  }

  setRelation (component) {
    const parent = this.getParentComponent(component)

    let parentArchived = this.getParentArchived(parent)

    if (component.archive.foreignKey === 'create') {
      component.archive.foreignKey = UUID.create()
      const table = this.schema.getTable(component.archive.tableId)
      const primaryTable = this.schema.getTable(parentArchived.tableId)
      table.createColumn(component.archive.foreignKey, `外键-${primaryTable.name}`, 'Identity')
    }

    if (!component.archive.primaryKey) {
      component.archive.primaryKey = this.schema.getTable(parentArchived.tableId).getPrimaryKey().id
    }
    const relationInfo = {
      primaryTable: parentArchived.tableId,
      primaryKey: component.archive.primaryKey,
      foreignTable: component.archive.tableId,
      foreignKey: component.archive.foreignKey,
      relationType: component.relationType
    }
    if (this.schema.relations.some(m => m.equalsTo(relationInfo))) {
      component.archive.relationId = this.schema.relations.find(m => m.equalsTo(relationInfo)).id
    } else {
      // 子表主表选择相同的表?
      component.archive.relationId = this.schema.createRelation(relationInfo).id
    }
  }

  getAllTable () {
    let useTable = _.cloneDeep(this.schema.tables)
    let tables = _.cloneDeep(this.options.tables)
    useTable.forEach(m => {
      if (m && m.id) {
        let table = tables.find(n => n.id === m.id)
        if (table) {
          table.columns = _.uniqBy(_.union(table.columns, m.columns), 'id')
          table.name = m.name
        } else {
          tables.unshift(m)
        }
      }
    })
    return tables
  }

  getColumns (tableId) {
    let useTable = _.cloneDeep(this.schema.tables.find(m => m.tableId === tableId))
    let table = _.cloneDeep(this.options.tables.find(m => m.id === tableId))
    let columns = []
    if (table) {
      columns = _.concat(columns, table.columns)
    }
    if (useTable) {
      columns = _.concat(columns, useTable.columns)
    }
    // 标记了删除的归档控件先提取出来
    let deleteColumns = []
    columns = _.uniqBy(columns, 'id')
    // todo: 未区分已删除的和用户手动重命名的
    columns = columns.filter(column => {
      if (column.name.includes('(已删除)')) {
        deleteColumns.push(column)
        return false
      }
      return true
    })
    // 然后拼接到最后面
    columns = _.concat(columns, deleteColumns)
    return columns
  }

  getAllComponent () {
    return this.getComponents().filter(m => m instanceof ColumnComponent)
  }

  // 获取同一级别的控件集合
  getSameLevelcomponent (component) {
    let components = []
    let parentComponent = this.getParentArchivedComponent(this.getParentComponent(component))
    if (this.component instanceof ProcessComponent &&
      this.component.path &&
      this.component.path.includes(this.getParentComponent(component).id)) {
      let path = this.component.path
      this.component.children
        .filter(m => path.includes(m.id))
        .forEach(m => {
          components = _.concat(components, m.archivedChildren.filter(m => !(m instanceof TableComponent)))
        })
    } else {
      components = parentComponent.archivedChildren.filter(m => !(m instanceof TableComponent))
    }
    return components
  }

  // 给控件名字新增 拼音 和 缩写
  async getPinyinByHanzi (name) {
    let result = {}
    await axios({
      method: 'get',
      url: '/shared-api/pinyin/getPinyinByHanzi',
      disableInterceptors: true,
      params: {hanzi: name}
    }).then(res => {
      result = res.data
    }).catch(res => {
      result = {pinyinName: '', pinyinFirstChar: ''}
    })
    return result
  }
}



// WEBPACK FOOTER //
// ./src/store/form/formService.js